module.exports = __webpack_public_path__ + "img/packing_slips.1363d424.png";